import styled from 'styled-components';

export const Nav = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 960px) {
    justify-content: initial;
  }
`;

export const NavItem = styled.h2<{ selected: boolean }>`
  display: block;
  font-weight: ${(props) => (props.selected ? 700 : 400)};
  font-size: 16px;
  color: ${(props) =>
    props.selected ? props.theme.colors.primary : props.theme.colors.secundary};
  padding: 22px 40px 22px 0;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
    font-weight: 700;
    cursor: pointer;
  }

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const NavUser = styled.div`
  display: flex;
  align-content: center;
  padding: 12px 0;

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 960px) {
    padding: 0;
  }
`;

export const Box = styled.div`
  height: 32px;
  width: 32px;
  margin: 0 12px 0 32px;

  @media screen and (max-width: 1200px) {
    margin: 0 12px 0 12px;
  }
`;

export const CompleteCircle = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 25px;
  padding-top: 12px;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
`;

export const Icon = styled.div`
  margin: 8px 0;
  color: ${(props) => props.theme.colors.primary};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 4px;
`;

export const Title = styled.h2`
  color: ${(props) => props.theme.colors.userDataColor};
  font-weight: 700;
  font-size: 16px;
  min-height: 16px;
  padding: 2px 0 6px 0;
  margin-bottom: 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 130px;
`;

export const Subtitle = styled.h2`
  color: ${(props) => props.theme.colors.userDataColor};
  font-weight: 400;
  font-size: 12px;
`;
